enum TemplateHeaderConst {
  DEFAULT = 'default',
  BURGER = 'burger',
  V5 = 'V5',
}

export default TemplateHeaderConst;
